import { useRef } from 'react';

import { getFeaturesEventPayload } from '@pflegia/util/functions/job-position/get-features-event-payload';

import { TrackingEventName } from '@shared/application/marketing/events/tracking-event-name';
import { trackEvent } from '@shared/application/tracking.service';

import { JobPositionCardTrackerProps } from '../../domains/job-board/components/wrappers/job-position-card-tracker';

type TrackingFnProps = Omit<JobPositionCardTrackerProps, 'children'> & Record<string, unknown>;

export const useTrackJobPositionFeatures = () => {
  const trackRef = useRef<Map<TrackingEventName, Set<string>>>(new Map());

  const handleTracking = (eventName: TrackingEventName, eventProps: TrackingFnProps) => {
    const { jobPosition, featuresBadges, ...others } = eventProps;
    const jobPositionId = jobPosition.id;

    if (trackRef.current.get(eventName)?.has(jobPositionId)) return;
    if (!trackRef.current.get(eventName)) trackRef.current.set(eventName, new Set());
    trackRef.current.get(eventName)?.add(jobPositionId);

    trackEvent(eventName, {
      // @ts-expect-error Generic types clash
      ...getFeaturesEventPayload(jobPosition, featuresBadges),
      ...others,
    });
  };

  return { handleTracking };
};
